// Business locations stay [longitude, latitude] in GCJ-02; the map displays BD-09.
const xPi = Math.PI * 3000 / 180
export function gcjToBd([lng, lat]) {
    const z = Math.sqrt(lng * lng + lat * lat) + 0.00002 * Math.sin(lat * xPi)
    const theta = Math.atan2(lat, lng) + 0.000003 * Math.cos(lng * xPi)
    return [z * Math.cos(theta) + 0.0065, z * Math.sin(theta) + 0.006]
}
export function bdToGcj([lng, lat]) {
    const x = lng - 0.0065
    const y = lat - 0.006
    const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * xPi)
    const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * xPi)
    return [z * Math.cos(theta), z * Math.sin(theta)]
}
export function validLocation(value) {
    return Array.isArray(value) && value.length === 2 &&
        value.every(n => typeof n === 'number' && Number.isFinite(n)) &&
        Math.abs(value[0]) <= 180 && Math.abs(value[1]) <= 90
}
let loading
export function loadBaiduMap() {
    if (window.BMap && window.BMap.Map) return Promise.resolve(window.BMap)
    if (loading) return loading
    loading = new Promise((resolve, reject) => {
        const script = document.createElement('script')
        const callback = '__gylBaiduMapReady'
        let timer
        const cleanup = () => {
            clearTimeout(timer)
            delete window[callback]
            script.onerror = null
        }
        const fail = () => {
            cleanup()
            script.remove()
            loading = null
            reject(new Error('地图暂不可用，请检查网络后重试'))
        }
        window[callback] = () => {
            if (!window.BMap || !window.BMap.Map) return fail()
            cleanup()
            resolve(window.BMap)
        }
        script.onerror = fail
        timer = setTimeout(fail, 15000)
        script.src = 'https://api.map.baidu.com/api?v=3.0&ak=y9B7qrmg86HL7V8w4Y1TaLWNZddwDIWF&callback=' + callback
        document.head.appendChild(script)
    })
    return loading
}



// WEBPACK FOOTER //
// ./src/utils/baiduMap.js